@if (loaded) {
  <main>
    @if (user) {
      <h1>
        {{ user.fullName }}
        @if (user.authorizations.length > 0) {
          <mat-form-field class="authorization-selection">
            <mat-select [value]="currentAuthorizationProfile" (selectionChange)="setAuthorizationProfile($event.value)">
              @for (auth of user.authorizations; track auth) {
                <mat-option [value]="auth">
                  {{ 'profile.roles.' + auth.role | translate }} - {{ auth.site }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </h1>
    }
    <div class="step-action-wrapper">
      <div class="step-action">
        @if (displayBackBtn()) {
          <button (click)="backButtonClicked()" mat-button>
            {{ 'profile.back' | translate }}
          </button>
        }
      </div>
      <div class="stepper-wrapper">
        <app-stepper [steps]="steps"> </app-stepper>
      </div>
      <div class="step-action">
        <button mat-button (click)="nextButtonClicked()" [disabled]="disableNextButton()">
          {{ (displayOverview() ? 'profile.done' : 'profile.continue') | translate }}
        </button>
      </div>
    </div>
    <div class="info-message">
      <em class="material-icons icon">info</em>
      <span>{{
        (displayWorkCenterList() ? 'profile.workCenterReplacementInfo' : 'profile.workOrderDateInfo') | translate
      }}</span>
    </div>
    <div class="profile-columns">
      @if (displaySiteList()) {
        <div class="profile-column">
          <div class="work-centers">
            <div class="dwo-input-group">
              <input
                id="search-work-centers"
                class="dwo-input"
                [placeholder]="'profile.filterWorkCenters' | translate"
                [(ngModel)]="searchSiteText"
                autocomplete="off"
              />
              @if (!searchSiteText) {
                <label for="search-work-centers">
                  <em class="material-icons icon">search</em>
                </label>
              }
              @if (searchSiteText) {
                <label id="clear-work-center-search" for="search-work-centers" (click)="clearSearchWorkCentersText()">
                  <em class="material-icons icon">close</em>
                </label>
              }
            </div>
            <div class="select-list">
              @for (site of getSites(); track site) {
                <div [className]="site.selected ? 'select-item selected' : 'select-item'" (click)="toggleSite(site.id)">
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ site.name }}</h2>
                  </div>
                  <div class="select-item-details">{{ site.name }}</div>
                  <div class="select-item-action">
                    <em class="material-icons icon">{{
                      site.selected ? 'radio_button_checked' : 'radio_button_unchecked'
                    }}</em>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (displayWorkCenterList()) {
        <div class="profile-column">
          <div class="work-centers">
            <div class="dwo-input-group">
              <input
                id="search-work-centers"
                class="dwo-input"
                [placeholder]="'profile.filterWorkCenters' | translate"
                [(ngModel)]="searchWorkCentersText"
                autocomplete="off"
              />
              @if (!searchWorkCentersText) {
                <label for="search-work-centers">
                  <em class="material-icons icon">search</em>
                </label>
              }
              @if (searchWorkCentersText) {
                <label id="clear-work-center-search" for="search-work-centers" (click)="clearSearchWorkCentersText()">
                  <em class="material-icons icon">close</em>
                </label>
              }
            </div>
            <div class="select-list">
              @for (workCenter of getWorkCenters(); track workCenter) {
                <div
                  [className]="workCenter.selected ? 'select-item selected' : 'select-item'"
                  (click)="toggleWorkCenter(workCenter.id)"
                >
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ workCenter.number }}</h2>
                    <div class="select-item-info">{{ workCenter.site }}</div>
                  </div>
                  <div class="select-item-details">{{ workCenter.name }}</div>
                  <div class="select-item-action">
                    <em class="material-icons icon">{{
                      workCenter.selected ? 'radio_button_checked' : 'radio_button_unchecked'
                    }}</em>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (displayProjectList()) {
        <div class="profile-column">
          <div class="projects">
            <div class="dwo-input-group">
              <input
                id="search-projects"
                class="dwo-input"
                [placeholder]="'profile.filterProjects' | translate"
                [(ngModel)]="searchProjectText"
                autocomplete="off"
              />
              @if (!searchProjectText) {
                <label for="search-work-centers">
                  <em class="material-icons icon">search</em>
                </label>
              }
              @if (searchProjectText) {
                <label id="clear-work-center-search" for="search-work-centers" (click)="clearSearchProjectText()">
                  <em class="material-icons icon">close</em>
                </label>
              }
            </div>
            <div class="select-list">
              @for (project of getProjects(); track project) {
                <div
                  [className]="project.selected ? 'select-item selected' : 'select-item'"
                  (click)="toggleProject(project.id)"
                >
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ project.name }}</h2>
                  </div>
                  <div class="select-item-action">
                    <em class="material-icons icon">{{
                      project.selected ? 'radio_button_checked' : 'radio_button_unchecked'
                    }}</em>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!-- overview -->
      @if (displayOverview()) {
        <div class="overview-container">
          <div class="selection-column">
            <div class="overview-list-header">Current Sites</div>
            <div class="select-list">
              @for (site of getSelectedSites(); track site) {
                <div class="select-item overview-item" (click)="confirmToggleSite(site)">
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ site.name }}</h2>
                  </div>
                  <div class="clear-item-action">
                    <em class="material-icons icon"> cancel </em>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="selection-column">
            <div class="overview-list-header">Current Work Centers</div>
            <div class="select-list">
              @for (workCenter of getSelectedWorkCenters(); track workCenter) {
                <div class="select-item overview-item" (click)="confirmToggleWorkCenter(workCenter)">
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ workCenter.number }}</h2>
                    <div class="select-item-info">{{ workCenter.name }}</div>
                  </div>
                  <div class="clear-item-action">
                    <em class="material-icons icon"> cancel </em>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="selection-column">
            <div class="overview-list-header">Current Projects</div>
            <div class="select-list">
              @for (project of getSelectedProjects(); track project) {
                <div class="select-item overview-item" (click)="confirmToggleProject(project)">
                  <div class="select-item-details">
                    <h2 class="select-item-title">{{ project.name }}</h2>
                  </div>
                  <div class="clear-item-action">
                    <em class="material-icons icon"> cancel </em>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </main>
}
